import React, { FC, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export const ScrollProvider: FC = ({ children }) => {
  const { hash } = useLocation();

  const sectionId = hash.slice(1);

  useEffect(() => {
    function scrollToSection() {
      if (!children) {
        return;
      }
      const sectionElement = document.getElementById(sectionId);

      if (sectionElement) {
        sectionElement.scrollIntoView({ behavior: 'smooth' });
      }
    }

    scrollToSection();
  }, [children, sectionId]);

  return <>{children}</>;
};
